import { ModuleWithProviders, NgModule } from '@angular/core';

import { UICurrencyFormatPipe } from './currency-format.pipe';

@NgModule({
	declarations: [UICurrencyFormatPipe],
	exports: [UICurrencyFormatPipe],
})
export class UICurrencyFormatPipeModule {
	static forRoot(): ModuleWithProviders<UICurrencyFormatPipeModule> {
		return {
			ngModule: UICurrencyFormatPipeModule,
			providers: [UICurrencyFormatPipe],
		};
	}
}
